/**
 * A site that refused our server (a country block, an access-denied page, a 401/403).
 * The first sentence is Emily's 2026-10-25 wording: it claims neither a password nor a
 * login. Shared by the review page's "Can't load" copy and the dashboard onboarding notice.
 */
export const SITE_REFUSED_SERVER_COPY = "This site didn't let our server open it.";
/** The same line plus the recovery that works: the extension runs in the user's own browser. */
export const SITE_REFUSED_USE_EXTENSION_COPY = `${SITE_REFUSED_SERVER_COPY} Capture it with the extension: it runs in your own browser.`;
//# sourceMappingURL=reviewSiteRefused.js.map